// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CLMZ","importantInfo":"styles_importantInfo__1XKV3"};